import Vue from 'vue'
import grid from './grid/index.vue'
import select from './select.vue'

Vue.component('app-cidade-grid', grid)
Vue.component('app-cidade-select', select)
